import {
  CountryCodeSelect,
  Group,
  Input,
  Stack,
  TextInput,
  type TextSearchProps,
} from '@inflearn/ds-react-next';
import { ClientSideOnly, useLang } from '@inflearn/i18n-tools';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export function PhoneInput({
  code,
  phoneNumber,
  onCodeChange,
  onNumberChange,
  size = 'md',
  error,
  showLabel = true,
  autoFocus = false,
  children,
}: {
  code: string;
  phoneNumber: string;
  onCodeChange: (code: string) => void;
  onNumberChange: (number: string) => void;
  size?: TextSearchProps['size'];
  error?: ReactNode;
  showLabel?: boolean;
  autoFocus?: boolean;
  children: React.ReactNode;
}) {
  const { lang } = useLang();
  const { t } = useTranslation();

  return (
    <Stack>
      <Input.Wrapper
        id="phone"
        size="md"
        label={showLabel ? t('휴대폰 번호 (숫자만 입력)') : undefined}
        w="100%"
        styles={{
          label: {
            whiteSpace: 'nowrap',
          },
        }}
      >
        <ClientSideOnly>
          {/* TODO: CountryCodeSelect가 서버사이드에서도 렌더링되도록 수정 */}
          <CountryCodeSelect
            lang={lang}
            value={code}
            onChange={(value: string | null) => {
              if (value === null) {
                return;
              }

              onCodeChange(value);
            }}
            size={size}
          />
        </ClientSideOnly>
        <Group gap={8} align="flex-start">
          <TextInput
            error={error}
            value={phoneNumber}
            type={'tel'}
            onChange={(e) => onNumberChange(e.target.value.replace(/[^0-9]/g, ''))}
            placeholder={t('휴대폰 번호 입력')}
            maxLength={255}
            autoFocus={autoFocus}
            size={size}
            styles={{
              root: {
                flex: '1 1 auto',
              },
            }}
          />
          {children}
        </Group>
      </Input.Wrapper>
    </Stack>
  );
}
